import {absCenterY, clearfix, btn_md, font_s_lg} from '@xpertdox_js/xdstyle';
import {colors} from '../../defaultSettings';

const menuItemCommon = {
  ...btn_md,
  borderBottom: '1px solid ' + colors.headerMenuBorderDrk,
}


export default {
  menuPanel: {
    position: 'absolute',
    top: '0',
    right: '30px',
    left: 'auto',
    background: colors.bg.headerMenu,
    color: colors.headerText,
    boxShadow: '-8px 4px 18px ' + colors.opacShadeLt,
    borderRight: 'none',
    animation: 'slide-in-from-left-w-fade .32s ease-out',
    width: '266px',
    transition: 'top .24s ease-out, height .32s ease-out',
    height: 'auto',
    overflow: 'hidden',
    zIndex: 20,
  },
  panelContent: {
    animation: 'slide-in-from-left .28s ease-out',
    backfaceVisibility: 'hidden',
    maxHeight: '320px',
    overflowY: 'auto',
    background: colors.bg.headerMenu,
  },
  menuTitle: {
    ...font_s_lg,
    padding: '10px',
    background: colors.bg.title,
    color: colors.title,
    margin: 0,
  },
  switchMenuItem: {
    ...clearfix,
    ...menuItemCommon,
  },
  buttonMenuItem: {
    ...menuItemCommon,
    padding: 0,
  },
  miButton: {
    width: '100%',
    background: 'none',
    textAlign: 'left',
    padding: '14px 8px',
    color: colors.headerText,
  },
  miButtonHov: {
    background: colors.bg.headerHov,
  },
  switchButton: {
    float: 'right',
    maxWidth: '30%',
    marginTop: '.2rem'
  },
  switchText: {
    float: 'left',
    position: 'relative',
    height: '22px',
    width: '70%',
    color: colors.headerText,
  },
  switchTextContent: {
    ...absCenterY,
    left: 0,
    width: '100%',
  },
  switchCompStyles: {
    containerOn: {
      background: colors.bg.on,
    },
    container: {
      background: colors.bg.off,
    }
  }
}
